import React, { useState, MouseEvent } from "react";
import { NavLink } from "react-router-dom";

interface MainLinkProps {
  to?: string;
  label: string;
  icon: React.ReactNode;
  onVisit: () => void;
  showTooltip: boolean;
  toggleSidebar: boolean;
  target?: string;
}

const styles = {
  mainLink:
    "h-10 rounded-lg w-full text-left flex items-center v-nav-hover",
  mainLinkActive:
    "h-10 rounded-lg border-lg w-full text-left flex items-center v-nav-active",
  navLink:
    "h-10 rounded-lg w-full text-left flex items-center v-nav-hover border-transparent",
  tooltip:
    "absolute left-full ml-2 p-4 rounded v-nav whitespace-nowrap z-1000 -translate-y-full"
};

export default function MainLink({
  to,
  label,
  icon,
  onVisit,
  showTooltip,
  toggleSidebar,
  target
}: MainLinkProps) {
  const [isHovered, setIsHovered] = useState(false);

  const handleClick = (_e: MouseEvent<HTMLAnchorElement>) => {
    onVisit();
  };

  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <NavLink
        to={to || ""}
        className={({ isActive }) =>
          isActive ? styles.mainLinkActive : styles.navLink
        }
        onClick={handleClick}
        target={target}
      >
        <div className="flex items-center ml-2">
          {icon}
          {showTooltip && <span className="pl-4 text-sm">{label}</span>}
        </div>
      </NavLink>

      {!showTooltip && isHovered && (
        <div>
          <div className="absolute left-12 h-14 w-4 bg-transparent -translate-y-full pointer-events-none" />
          <div className={styles.tooltip}>
            <NavLink to={to || ""} target={target}>
              {label}
            </NavLink>
          </div>
        </div>
      )}
    </div>
  );
}
